import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class WaktuSolatService {
  private url = 'https://mpt.i906.my/api/prayer';
  // private url_2 = 'http://smart-falak.test/api/shared';
  private url_3 = 'https://www.e-solat.gov.my/index.php?r=esolatApi/TakwimSolat&period=today&zone=';

  //production
  // private url_2 = 'https://api.efalak.muftiselangor.gov.my/api/shared';

  baseUrl = environment.baseUrl;
  private url_2 = `${this.baseUrl}api/shared`;


  // private url_2 = 'https://api.smart-falak.ezran.my/api/shared';

  constructor(private http: HttpClient) {}

  getLocation(lat: any, lang: any): Observable<any> {
    return this.http.get(this.url + '/' + lat + ',' + lang);
  }

  getWaktuSolat(code: any): Observable<any> {
    return this.http.get(this.url_3 + code,{headers: { skipInterceptor: 'true' }});
  }

  getWaktuSolatUpdate(code: any): Observable<any> {
    return this.http.get(this.url_3 + code);
  }

  getTarikhHijri(date:any): Observable<any> {
    return this.http.get<any>(this.url_2 + '/getTarikh/' + date);
  }
}
